"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainerWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const shadow_svg_1 = __importDefault(require("@components/icons/shadow.svg"));
const stopShado_svg_1 = __importDefault(require("@components/icons/stopShado.svg"));
const blikStart_svg_1 = __importDefault(require("@components/icons/blikStart.svg"));
const blikStop_svg_1 = __importDefault(require("@components/icons/blikStop.svg"));
const ButtonContainer = styled_components_1.default.div `
    position: relative;
    background: ${({ isStarted, isCheckButton }) => isCheckButton
    ? 'linear-gradient(130.29deg, #8188FF 13.21%, #6E76FB 81.73%)'
    : isStarted
        ? 'linear-gradient(130.29deg, #FE2B2B 13.21%, #EF0F45 81.73%)'
        : 'linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%);'};
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 228px;
    height: 80px;
    //border-radius: 50px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 40px;
    font-weight: 800;
    font-family: inter;
    border: 5px solid #ffffff;
    padding: 10px 20px;
    border-radius: 200px;
    @media (max-width: 1024px) {
        font-size: 30px;
        padding: 8px 16px;
    }

    @media (max-width: 768px) {
        font-size: 20px;
        padding: 6px 12px;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        overflow: hidden;
        bottom: 0;
    }

    @media (max-width: 480px) {
        font-size: 16px;
        //padding: 4px 8px;
        //border-radius: 30px;
    }
    @media (max-width: 400px) {
        width: 60px;
        height: 60px;
    }

    @media (max-height: 650px) {
        ${({ isCheckButton }) => isCheckButton && `
            font-size: 25px;
            padding: 4px 8px;
            border-radius: 30px;
        `}
    }

    @media (max-height: 600px) {
        font-size: 25px;
        padding: 4px 8px;
        border-radius: 30px;
    }
`;
exports.ButtonContainerWrapper = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    z-index: 1;
    @media (max-height: 450px) {
        margin-top: 10px;
    }
`;
const spin = (0, styled_components_1.keyframes) `
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;
const LoadingSpinner = styled_components_1.default.div `
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #ffffff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: ${spin} 1s linear infinite;

    @media (max-width: 768px) {
        width: 18px;
        height: 18px;
    }
`;
const BlikwDiv = styled_components_1.default.div `
    position: absolute;
    top: 5px;
    left: 13px;
    height: 60px;
    overflow: hidden;

    svg {
        width: 100%;
        height: 100%;
    }
    @media (max-width: 400px) {
        left: 0;
        top: -10px;
        scale: 55%;
    }
`;
const ShadowDiv = styled_components_1.default.div `
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: auto;
    overflow: hidden;

    svg {
        width: 100%;
        height: 100%;
    }
`;
const Button = ({ label, onClick, isStarted, isCheckButton, isLoading, isShowShadow = true }) => (react_1.default.createElement(ButtonContainer, { onClick: onClick, isStarted: isStarted, isCheckButton: isCheckButton },
    isShowShadow ? react_1.default.createElement(BlikwDiv, null, !isStarted ? react_1.default.createElement(blikStart_svg_1.default, null) : react_1.default.createElement(blikStop_svg_1.default, null)) : react_1.default.createElement(react_1.default.Fragment, null),
    isLoading ? react_1.default.createElement(LoadingSpinner, null) : label,
    isShowShadow ? react_1.default.createElement(ShadowDiv, null, !isStarted ? react_1.default.createElement(shadow_svg_1.default, null) : react_1.default.createElement(stopShado_svg_1.default, null)) : react_1.default.createElement(react_1.default.Fragment, null)));
exports.default = Button;
